<template>
	<div>
		<router-view></router-view>
	</div>
</template>

<script>
import { get } from '@/http/request'
import { mapState, mapMutations } from "vuex";
export default {
	components: {
	},
	data() {
		return {
		}
	},
	created() {
		this.checkDevice()
	},
	computed: {
		...mapState(["defaultLang"]),
	},
	methods: {
		...mapMutations(["setLangList", "setDefaultLang", "setKefu", "setShareUrl", "setConfig"]),

		async checkDevice() {
			const res = await get(this.$apis.getConfig, { showLoading: false })
			if (res.code != 1) return
			console.log(res.data, '基础数据');
			this.setConfig(res.data)
			this.setKefu(res.data.kefu)
			this.setLangList(res.data.langList)
			if (!this.defaultLang) {
				this.setDefaultLang(res.data.defaultLang)
			}
			this.setShareUrl(res.data.share_url)
		}
	}
}
</script>
<style>
html,
body,
#app {
	width: 100%;
	height: 100%;
	background-color: #000;
	overscroll-behavior: none;
}
</style>
